import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, ClockIcon } from 'lucide-react';
const RESET_HOURS = 11;
const RESET_MINUTES = 47;
const RESET_SECONDS = 22;
export const FloatingCountdown = () => {
  const [time, setTime] = useState({
    hours: RESET_HOURS,
    minutes: RESET_MINUTES,
    seconds: RESET_SECONDS
  });
  useEffect(() => {
    const tick = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds -= 1;
        } else if (minutes > 0) {
          minutes -= 1;
          seconds = 59;
        } else if (hours > 0) {
          hours -= 1;
          minutes = 59;
          seconds = 59;
        } else {
          // Loop infinitely — reset to fresh chunk
          hours = RESET_HOURS;
          minutes = RESET_MINUTES;
          seconds = RESET_SECONDS;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(tick);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <motion.a href="#pricing" initial={{
    y: -60,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    delay: 0.6,
    type: 'spring',
    stiffness: 200,
    damping: 22
  }} className="fixed top-0 left-0 right-0 z-40 block group" aria-label="Quedan pocos cupos para El Arquitecto de Sistemas — Ver planes" data-id="element-35">
      {/* Animated gradient backdrop (semi-transparent) */}
      <div className="relative overflow-hidden backdrop-blur-md bg-gradient-to-r from-[#061528]/85 via-[#0a2540]/85 to-[#061528]/85 border-b border-primary/40 shadow-[0_4px_30px_rgba(34,211,238,0.25)]" data-id="element-36">
        {/* Moving shimmer */}
        <div className="absolute inset-0 opacity-40 pointer-events-none" style={{
        background: 'linear-gradient(90deg, transparent 0%, rgba(34,211,238,0.18) 30%, rgba(45,212,191,0.18) 50%, rgba(34,211,238,0.18) 70%, transparent 100%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 3.5s linear infinite'
      }} data-id="element-37" />

        <div className="relative max-w-7xl mx-auto px-3 sm:px-4 py-2.5 md:py-3 flex items-center justify-center gap-2 md:gap-4 flex-wrap" data-id="element-38">
          {/* Left pulse flame */}
          <span className="relative inline-flex items-center justify-center shrink-0" data-id="element-39">
            <span className="absolute inline-flex h-7 w-7 rounded-full bg-accent/40 animate-ping" data-id="element-40"></span>
            <FlameIcon className="relative w-5 h-5 md:w-6 md:h-6 text-accent drop-shadow-[0_0_8px_rgba(45,212,191,0.8)]" data-id="element-41" />
          </span>

          {/* Headline */}
          <p className="text-[12px] sm:text-sm md:text-base font-bold text-white tracking-wide uppercase text-center leading-tight" data-id="element-42">
            <span className="hidden sm:inline" data-id="element-43">⚡ </span>
            Quedan pocos cupos para{' '}
            <span className="bg-gradient-to-r from-primary via-cyan-300 to-accent bg-clip-text text-transparent font-black" data-id="element-44">
              EL ARQUITECTO DE SISTEMAS
            </span>
          </p>

          {/* Countdown */}
          <div className="flex items-center gap-1 md:gap-1.5 font-mono font-black text-white" data-id="element-45">
            <ClockIcon className="w-4 h-4 md:w-5 md:h-5 text-primary mr-0.5 md:mr-1" data-id="element-46" />
            <span className="bg-white/10 border border-primary/30 rounded-md px-1.5 py-0.5 md:px-2 md:py-1 text-[12px] sm:text-sm md:text-base tabular-nums" data-id="element-47">
              {pad(time.hours)}
              <span className="text-cyan-200/60 text-[10px] md:text-xs ml-0.5" data-id="element-48">
                h
              </span>
            </span>
            <span className="text-primary/70" data-id="element-49">:</span>
            <span className="bg-white/10 border border-primary/30 rounded-md px-1.5 py-0.5 md:px-2 md:py-1 text-[12px] sm:text-sm md:text-base tabular-nums" data-id="element-50">
              {pad(time.minutes)}
              <span className="text-cyan-200/60 text-[10px] md:text-xs ml-0.5" data-id="element-51">
                m
              </span>
            </span>
            <span className="text-primary/70" data-id="element-52">:</span>
            <span className="bg-white/10 border border-primary/30 rounded-md px-1.5 py-0.5 md:px-2 md:py-1 text-[12px] sm:text-sm md:text-base tabular-nums" data-id="element-53">
              {pad(time.seconds)}
              <span className="text-cyan-200/60 text-[10px] md:text-xs ml-0.5" data-id="element-54">
                s
              </span>
            </span>
          </div>

          {/* CTA arrow */}
          <span className="hidden md:inline-flex items-center gap-1 text-[#00F5A0] font-black text-sm uppercase tracking-wider group-hover:translate-x-1 transition-transform" data-id="element-55">
            Ver planes →
          </span>
        </div>
      </div>

      <style data-id="element-56">{`
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </motion.a>;
};